import './hound2/style';
import FormStructure from './hound2/form_structure';

export default FormStructure;